<!--
Author: TangChen
Date: 2018-11-06
Desc: CRS信息，由index.js 配置引入
-->
<template>
    <div :class="'view-investor-change view bg-white ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/orginfo' }">
                    信息中心
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <el-row class="investor">
            <el-col :span="24" class="investor-change-tit">
                <div class="investor-box cate">
                    <i class="investor-now" :class="{'pro':cate==='1'}" />
                    <div class="investor-mes">
                        <span class="tit">您现在的投资者类型是：</span>
                        <span class="mes">{{ cateVal }}</span>
                    </div>
                </div>
                <div class="investor-box">
                    <i class="investor-now" :class="{'ord':cate==='1'}" />
                    <div class="investor-mes">
                        <span class="tit">{{unconvertible?"不可转换为":"可转换为"}}</span>
                        <span class="mes">{{ (cate==='1'?'普通':'专业')+'投资者' }}<span v-if="innvestorInfo.appstatus === '1'" class="red">（正在审核中）</span></span>
                    </div>
                </div>
            </el-col>
            <el-col v-if="cate!=='1'" :span="24" class="investor-info">
                <p class="tit">
                    {{ '同时满足以下条件的机构普通投资者可申请转换为'+(cate==='1'?'普通':'专业')+'投资者' }}
                </p>
                <p class="list">
                    专I 机构投资者分类中除法人或其他组织外的类型;
                </p>
                <p class="list">
                    专II 净资产>=2000万 且 金融资产>=1000万 且 投资经历>=2年;
                </p>
                <p class="list">
                    专III 净资产>=1000万 且 金融资产>=500万 且 投资经历>=1年的除专业投资者外的法人或其他组织;
                </p>
                <!-- <p v-if="cate==='0'" class="list">
                    净资产>=2000万 且 金融资产>=1000万 且 投资经历>=2年；
                </p> -->
                <p class="note">
                    金融资产是指银行存款、股票、债券、基金、份额、资产管理计划、银行理财产品、信托计划、保险产品、期货及其他衍生品等。
                </p>
                <p class="note">
                    前款所称金融资产，是指银行存款、股票、债券、基金份额、资产管理计划、银行理财产品、信托计划、保险产品、期货及其他衍生产品等。
                </p>
            </el-col>
            <el-col v-if="innvestorInfo.appstatus !== '1'" class="investor-form two-cols-form" :span="24">
                <el-form
                    ref="innvestorInfo"
                    :model="innvestorInfo"
                    :rules="rules"
                    :label-width="cate==='0'?'160px':(innvestorInfo.needcheckpwd==='1'?'100px':'16px')"
                    class="acct-form"
                    size="small"
                    v-on:submit.native.prevent
                >
                    <el-col v-if="!unconvertible&&cate==='0'" :span="12">
                        <!--<el-form-item label="投资者分类：" class="form-text">-->
                            <!--<div class="text-con">-->
                                <!--{{ $cache.getDict('120048',innvestorInfo.custtype) }}-->
                            <!--</div>-->
                        <!--</el-form-item>-->
                        <el-form-item label="投资者分类：" prop="custtype" class="required">
                            <el-select
                                v-model="innvestorInfo.custtype"
                                placeholder="请选择投资者分类"
                                v-on:change="innvestorInfo.finorgtype = ''"
                            >
                                <el-option
                                    v-for="item in $cache.getDict('120048')||[]"
                                    v-show="(invtp==='2'&&item.subitem==='12')||(invtp==='0'&&item.subitem!=='11'&&item.subitem!=='12'&&item.subitem!=='14')"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="innvestorInfo.custtype==='02'" label="金融机构类型：" prop="finorgtype" class="required">
                            <el-select
                                v-model="innvestorInfo.finorgtype"
                                filterable
                                placeholder="请选择金融机构类型"
                            >
                                <el-option
                                    v-for="item in $cache.getDict('120049')||[]"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!unconvertible&&cate==='0'" :span="12">
                        <el-form-item label="客户全称：">
                            <div class="text-con">
                                {{ innvestorInfo.custname }}
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!unconvertible&&cate==='0'" :span="12">
                        <el-form-item label="证件类型：" class="form-text">
                            <div class="text-con">
                                {{ $cache.getDict('130008',innvestorInfo.certificatetype) }}
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!unconvertible&&cate==='0'" :span="12">
                        <el-form-item label="证件号码：">
                            <div class="text-con">
                                {{ innvestorInfo.certificateno }}
                            </div>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col v-if="cate==='0'" :span="12">
                        <el-form-item label="经办人类型：">
                            <div class="text-con">
                                {{ $cache.getDict('130007',innvestorInfo.certificatetype) }}
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="cate==='0'" :span="12">
                        <el-form-item label="经办人号码：">
                            <div class="text-con">
                                {{ innvestorInfo.certificateno }}
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="cate==='0'" :span="12">
                        <el-form-item label="经办人姓名：">
                            <div class="text-con">
                                {{ innvestorInfo.custname }}
                            </div>
                        </el-form-item>
                    </el-col> -->
                    <el-col v-if="!unconvertible&&innvestorInfo.custtype==='01' &&cate==='0'" :span="12">
                        <el-form-item label="年末金融资产：" prop="financialassets" class="required">
                            <el-input
                                v-model.trim="innvestorInfo.financialassets"
                                placeholder="请输入年末金融资产"
                                maxlength="8"
                            />
                            <span class="text-con">&nbsp;万元</span>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!unconvertible&&innvestorInfo.custtype==='01' &&cate==='0'" :span="12">
                        <el-form-item label="年末净资产：" prop="netassets" class="required">
                            <el-input
                                v-model.trim="innvestorInfo.netassets"
                                placeholder="请输入年末净资产："
                                :maxlength="8"
                            />
                            <span class="text-con">&nbsp;万元</span>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!unconvertible&&innvestorInfo.custtype==='01' &&cate==='0'" :span="12">
                        <el-form-item label="投资经历：" prop="investexp" class="required">
                            <el-input
                                v-model.trim="innvestorInfo.investexp"
                                placeholder="请输入投资经历"
                                :maxlength="2"
                            />
                            <span class="text-con">&nbsp;年</span>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col v-if="cate==='0'" :span="12">
                        <el-form-item label="投资工作经历：" prop="investwork" class="required">
                            <el-input
                                v-model.trim="innvestorInfo.investwork"
                                placeholder="请输入投资工作经历"
                                :maxlength="2"
                            />
                            <span class="text-con">&nbsp;年</span>
                        </el-form-item>
                    </el-col> -->
                    <!-- <el-col v-if="cate==='0'" :span="12">
                        <el-form-item label="相关从事职业：" prop="investtype" class="required">
                            <el-select
                                v-model.trim="innvestorInfo.investtype"
                                filterable
                                placeholder="请选择相关从事职业"
                            >
                                <el-option
                                    v-for="item in perinvesttypes"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                    <el-col v-if="isPwdCheck && !unconvertible" :span="12">
                        <el-form-item label="交易密码：" prop="tradepwd" class="required">
                            <el-input
                                v-model.trim="innvestorInfo.tradepwd"
                                placeholder="请输入交易密码"
                                :maxlength="20"
                                type="password"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="about">
                        <el-form-item label="" class="no-margin" >
                            <div class="text-con unconvertibleTip"  v-if="unconvertible">
                                符合《证券期货投资者管理办法》第八条第(四)、 (五）项规定的专业投资者，可选择成为普通投资者。
                            </div>
                            <div class="text-con">
                                我要了解 <span class="like-a" v-on:click.prevent="otherVisible=true">普通投资者与专业投资者之间的区别</span>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="unconvertible" class="btn-group tips">
                        您的风险承受能力不符合被划分为专业投资者的条件。
                    </el-col>
                    <el-col :span="24" class="btn-group">
                        <el-button v-if="!unconvertible" type="primary" class="medium" v-on:click="submitInfo('innvestorInfo')">
                            申请转换
                        </el-button>
                        <el-button class="medium" v-on:click="$router.back()">
                            返回
                        </el-button>
                    </el-col>
                </el-form>
            </el-col>
        </el-row>
        <!--弹窗提示-->
        <!--投资者转换风险警示-->
        <el-dialog
            v-if="cate==='0'"
            title="投资者转换风险警示"
            :visible.sync="dialogVisible"
            class="prop info-tips"
            width="880px"
        >
            <div class="investor-tips">
                <el-alert title="您已达到专业投资者条件，请阅读风险警示选择是否继续转换" type="warning" show-icon :closable="false" />
                <div class="investor-info">
                    <p class="list">
                        本人经贵司认定为普通投资者，经本人审慎考虑，现决定自愿申请转化为贵司的专业投资者。本人已充分理解专业投资者与普通投资者的区别。
                    </p>
                    <p class="list">
                        包括但不限于履行投资者适当性义务差别、投资风险的差别等。转化为专业投资者后，将自主承担可能产生的风险和后果。本人承诺所提供材料真实、准确、完整。
                    </p>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-on:click="dialogVisible = false">
                    暂不转换
                </el-button>
                <el-button type="primary" v-on:click="agreeToProfessional">
                    我已阅知风险，并同意继续转换为专业投资者
                </el-button>
            </div>
        </el-dialog>
        <!--投资者转换提示-->
        <el-dialog
            title="投资者转换提示"
            :visible.sync="investorVisible"
            class="prop"
            width="420px"
            :show-close="false"
        >
            <div class="info-box">
                <el-alert :title="changeMsg" type="warning" show-icon :closable="false" />
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-if="btnMsg" v-on:click.once="$router.back()">
                    返回
                </el-button>
                <el-button v-else type="primary" v-on:click.prevent="investorVisible=false">
                    取消
                </el-button>
                <el-button v-if="btnMsg" type="primary" v-on:click.prevent="again">
                    {{ btnMsg }}
                </el-button>
            </div>
        </el-dialog>
        <!--普通投资者与专业投资者之间的区别-->
        <el-dialog title="普通投资者与专业投资者之间的区别" :visible.sync="otherVisible" class="prop" width="1020px">
            <div class="investor-tips">
                <p>根据《证券期货投资者适当性管理办法》：</p>
                <div class="investor-info">
                    <p class="list">
                        投资者分为普通投资者与专业投资者。
                    </p>
                    <p class="list">
                        普通投资者在信息告知、风险警示、适当性匹配等方面 享有特别保护。
                    </p>
                    <p class="list">
                        符合下列条件之一的是专业投资者：
                    </p>
                    <p class="list">
                        （一）经有关金融监管部门批准设立的金融机构，包括 证券公司、期货公司、基金管理公司及其子公司、商业银行、
                        保险公司、信托公司、财务公司等；经行业协会备案或者登 记的证券公司子公司、期货公司子公司、私募基金管理人。
                    </p>
                    <p class="list">
                        （二）上述机构面向投资者发行的理财产品，包括但不 限于证券公司资产管理产品、基金管理公司及其子公司产
                        品、期货公司资产管理产品、银行理财产品、保险产品、信 托产品、经行业协会备案的私募基金。
                    </p>
                    <p class="list">
                        （三）社会保障基金、企业年金等养老基金，慈善基金 等社会公益基金，合格境外机构投资者（QFII）、人民币合
                        格境外机构投资者（RQFII）。
                    </p>
                    <p class="list">
                        （四）同时符合下列条件的法人或者其他组织： 1.最近 1 年末净资产不低于 2000 万元； 2.最近 1 年末金融资产不低于
                        1000 万元； 3.具有 2 年以上证券、基金、期货、黄金、外汇等投资 4 经历。
                    </p>
                    <p class="list">
                        （五）同时符合下列条件的自然人： 1.金融资产不低于 500 万元，或者最近 3 年个人年均收 入不低于 50 万元；
                        2.具有 2 年以上证券、基金、期货、黄金、外汇等投资 经历，或者具有 2 年以上金融产品设计、投资、风险管理及
                        相关工作经历，或者属于本条第（一）项规定的专业投资者 的高级管理人员、获得职业资格认证的从事金融相关业务的 登录会计师和律师。
                        前款所称金融资产，是指银行存款、股票、债券、基金 份额、资产管理计划、银行理财产品、信托计划、保险产品、期货及其他衍生产品等。
                    </p>
                    <p class="list">
                        经营机构可以根据专业投资者的业务资格、投 资实力、投资经历等因素，对专业投资者进行细化分类和管理。
                    </p>
                    <p class="list">
                        专业投资者之外的投资者为普通投资者。 经营机构应当按照有效维护投资者合法权益的要求，综
                        合考虑收入来源、资产状况、债务、投资知识和经验、风险
                        偏好、诚信状况等因素，确定普通投资者的风险承受能力，对其进行细化分类和管理。符合下列条件之一的普通投资者可以申请转化成为专
                        业投资者，但经营机构有权自主决定是否同意其转化：
                    </p>
                    <p class="list">
                        （一）最近 1 年末净资产不低于 1000 万元，最近 1 年 末金融资产不低于 500 万元，且具有 1 年以上证券、基金、
                        期货、黄金、外汇等投资经历的除专业投资者外的法人或其 他组织；
                    </p>
                    <p class="list">
                        （二）金融资产不低于 300 万元或者最近 3 年个人年均 收入不低于 30 万元，且具有 1 年以上证券、基金、期货、
                        黄金、外汇等投资经历或者 1 年以上金融产品设计、投资、 风险管理及相关工作经历的自然人投资者。
                    </p>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" v-on:click.prevent="otherVisible=false">
                    我已了解
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "InvestorChange",
    mixins: [mixin],
    data () {
        return {
            dialogVisible: false,
            investorVisible: false,
            otherVisible: false,
            cate: "",
            cateVal: "",
            invtp: "",
            innvestorInfo: {},
            perinvesttypes: [],
            changeMsg: "",
            isPwdCheck: false,
            btnMsg: "",
            query: null,
            rules: {
                custtype: [
                    { required: true, message: "请选择投资者分类", trigger: "change" }
                ],
                finorgtype: [
                    { required: true, message: "请选择金融机构类型", trigger: "change" }
                ],
                financialassets: [
                    { required: true, message: "请输入年末金融资产", trigger: "blur" }
                ],
                investtype: [
                    { required: true, message: "请选择相关从事职业", trigger: "change" }
                ],
                netassets: [
                    { required: true, message: "请输入年末净资产", trigger: "blur" }
                ],
                investexp: [
                    { required: true, message: "请输入投资经历", trigger: "blur" }
                ],
                investwork: [
                    { required: true, message: "请输入投资工作经历", trigger: "blur" }
                ],
                tradepwd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ]
            },
            needtest: ""
        };
    },
    watch: {
        cate (val) {
            this.cateVal = this.$cache.getDict("120051", val);
        },
        "innvestorInfo.financialassets" (val) {
            this.mustNum(val, "financialassets");
        },
        "innvestorInfo.avgincome" (val) {
            this.mustNum(val, "avgincome");
        },
        "innvestorInfo.investexp" (val) {
            this.mustNum(val, "investexp");
        },
        "innvestorInfo.investwork" (val) {
            this.mustNum(val, "investwork");
        }
    },
    computed: {
        unconvertible(){
            const custrisk = this.$cache.getUser()&&this.$cache.getUser().custrisk;
            return custrisk!=="03"&&custrisk!=="04"&&custrisk!=="05"
        }
    },
    created () {
        // 重新提取最小日期
        this.perinvesttypes = this.$cache.getDict("120050");
        this.isPwdCheck = this.$cache.getPwdCheck("P1");
        this.getInvestor();
        const info = this.$cache.getUser();
        this.invtp = info.invtp;
    },
    methods: {
        /* 提交表单数据，校验用户信息 */
        submitInfo (formName) {
            const _this = this;
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    let _newObj = {};
                    if (_this.cate === "0") {
                        _newObj = _this.$util.getObjParam(_this.innvestorInfo, "certificatetype,certificateno,custfullname,custtype,financialassets,investexp,netassets,finorgtype");
                    }
                    _newObj.tradepwd = _this.$util.enc(_this.innvestorInfo.tradepwd);
                    // _newObj.peravgincome = "",
                    // _newObj.perinvesttype = "",
                    // _newObj.perinvestwork = "";
                    // 普通转专业
                    if (_this.cate === "0") {
                        _this.$util.request("acct/changetype/check", _newObj, "POST").then(res => {
                            if (res.data) {
                                if (res.data[0].assetcheckresult !== "0") {
                                    _this.dialogVisible = true;
                                    _this.needtest = res.data[0].needtest;
                                } else {
                                    _this.changeMsg = "您还未达到专业投资者条件，无法进行转换";
                                    _this.btnMsg = "";
                                    _this.investorVisible = true;
                                }
                            }
                        });
                        //  专业转普通
                    } else if (_this.cate === "1") {
                        _this.$util.request("acct/changetype/professional2ordinary", _newObj, "POST").then(res => {
                            if (res.data) {
                                let msg = "";
                                if (_this.innvestorInfo.needcheck === "0") {
                                    _this.$cache.refreshUser();
                                    msg = "您已成功从专业投资者转换为普通投资者";
                                } else {
                                    msg = "您已成功发起专业投资者转换为普通投资者申请，审核通过后将转为普通投资者";
                                }
                                if (res.data[0].confirmflag === "0") {
                                    _this.$message({
                                        type: "success",
                                        message: msg + "，3秒后跳转到转换资料上传页面",
                                        onClose: function () {
                                            _this.$router.push({ name: "invdataup" });
                                        }
                                    });
                                    return false;
                                }
                                _this.$message({
                                    type: "success",
                                    message: msg + "，3秒后回到个人信息页面",
                                    onClose: function () {
                                        _this.$router.push({ name: "orginfo" });
                                    }
                                });
                            } else {
                                _this.$alert(res.msg,"温馨提示");
                                /* _this.$message({
                                    type: "error",
                                    message: res.msg
                                }); */
                            }
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        // 是否上传转换文件
        again () {
            if (this.innvestorInfo.appstatus === "2") {
                this.investorVisible = false;
                this.$router.push({ name: "invdataup" });
            } else if (this.innvestorInfo.appstatus === "3") {
                this.investorVisible = false;
            } else {
                this.investorVisible = false;
                this.$router.back();
            }
        },
        // 转换为专业投资者
        agreeToProfessional () {
            const _this = this;
            this.dialogVisible = false;
            if (_this.needtest === "0") {
                this.$util.request("acct/changetype/ordinary2professional", {}, "POST").then(res => {
                    if (res.data) {
                        _this.$router.push({ name: "invdataup" });
                    }
                });
            } else {
                _this.$router.push({ name: "invknowledgetest" });
            }
        },
        // 获取投资者转换信息
        getInvestor () {
            const _this = this;
            this.$util.request("acct/changetype/suitableinfo").then(res => {
                if (res.data) {
                    _this.innvestorInfo = res.data[0];
                    const custrisk = this.$cache.getUser()&&this.$cache.getUser().custrisk;
                    if (_this.innvestorInfo.appstatus === "2"&&(custrisk==="03"||custrisk==="04"||custrisk==="05")) {
                        _this.changeMsg = "您还没有提交投资者转换所需文件资料，请前往提交";
                        _this.btnMsg = "前往提交";
                        _this.investorVisible = true;
                    }
                    if (_this.innvestorInfo.appstatus === "3"&&(custrisk==="03"||custrisk==="04"||custrisk==="05")) {
                        _this.changeMsg = "您的投资者转换申请审核失败，" + _this.innvestorInfo.failedreason;
                        _this.btnMsg = "重新申请";
                        _this.investorVisible = true;
                    }
                    _this.cate = _this.innvestorInfo.professionflag;
                    _this.isPwdCheck = _this.cate === "0" ? this.$cache.getPwdCheck("P2") : this.$cache.getPwdCheck("P1");
                    const _x = _this.$cache.getUser();
                    _x.professionflag = _this.cate;
                    _this.$store.dispatch("setInfo", _x);
                }
            });
        },
        // 只能输入数字
        mustNum (val, param) {
            const _x = this.$util.filterNum(val);
            clearTimeout(this.query);
            this.query = setTimeout(() => {
                this.$set(this.innvestorInfo, param, _x);
            }, 1);
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
/*用户信息 */
.view-investor-change {
    .dialog-footer {
        text-align: center;
    }
    .investor {
        padding: 30px 30px 20px;
        .investor-change-tit {
            text-align: center;
            .investor-box {
                display: inline-block;
                vertical-align: middle;
                &:first-of-type:after {
                    content: "";
                    width: 46px;
                    height: 15px;
                    display: inline-block;
                    vertical-align: middle;
                    margin: 0 40px;
                    background: url($investor) -139px -15px no-repeat;
                }
                &.cate {
                    .investor-now {
                        background: $color-b url($investor) 15px 11px no-repeat;
                        &.pro {
                            background: $color-b url($investor) -58px 11px no-repeat;
                        }
                    }
                    .investor-mes {
                        .tit {
                            color: $text-color1;
                        }
                        .mes {
                            color: $color-b;
                        }
                    }
                }
                .investor-now {
                    width: 64px;
                    height: 64px;
                    background: #d6d6d6 url($investor) -58px 11px no-repeat;
                    display: inline-block;
                    border-radius: 100%;
                    vertical-align: middle;
                    &.ord {
                        background: #d6d6d6 url($investor) 15px 11px no-repeat;
                    }
                }
                .investor-mes {
                    display: inline-block;
                    vertical-align: middle;
                    margin-left: 12px;
                    text-align: left;
                    .tit {
                        color: $text-color3;
                        font-size: $f16;
                        line-height: 30px;
                        display: block;
                    }
                    .mes {
                        color: $text-color1;
                        font-size: $f22;
                        line-height: 30px;
                        display: block;
                        .red {
                            color: $color-c;
                        }
                    }
                }
            }
        }
        .investor-info {
            margin: 32px 0 22px;
        }
    }
    .investor-info {
        margin: 5px 0 20px;
        border-radius: 4px;
        background: $bg5;
        padding: 10px 17px;
        border: 1px solid $border-color8;
        .tit {
            color: $color-a;
            font-size: $f16;
            line-height: 36px;
        }
        .list {
            color: $text-color1;
            line-height: 24px;
            span {
                color: $color-c;
            }
        }
        .note {
            &:before {
                content: "*";
                color: $color-c;
            }
            color: $text-color3;
            line-height: 24px;
        }
    }
    .no-margin {
        text-align: center;
        .unconvertibleTip {
            margin-top: 30px;
            color: $text-color3;
        }
    }
    .about .el-form-item__content {
        margin-left: 0 !important;
    }
    .tips{
        color: red;
        font-weight: bold;
    }
}
</style>
